<template>
    <div class="cashout-sectionOne-main">
        <div class="cashout-sectionOne-main__title">
            <span class="strong"> Creators Commission Request</span>
        </div>

        <div class="cashout-sectionOne-main__description">
            <div class="desc">
                As a member of the Creators Club you’ll have the option to
                initiate a Creators Commission - meaning you can turn your
                in-game Coyns into real world currency!.
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'RequestCashbackHeader',
};
</script>

<style scoped lang="scss">
.cashout-sectionOne-main {
    display: flex;
    height: fit-content;
    overflow: hidden;
    background: url('~Images/request_cashback/cashout_image.png') no-repeat
        center center;
    background-size: cover;
    position: relative;
    border-radius: 8px;
    flex-direction: column;
    padding: 5% 4%;

    @media (min-width: $sm-up) {
        background-size: 100%;
    }

    @media (min-width: 1000px) and (max-width: 1260px) {
        background-size: 100%;
        padding: 2%;
    }

    &__title {
        font-family: $politica-font;
        font-size: 45px;
        font-weight: 700;
        letter-spacing: 0.71px;
        line-height: 53px;
        color: $blue-main;
        padding: 2% 0;

        @media (max-width: $xs-up) {
            text-align: center;
            padding: 0;
        }
    }

    &__description {
        flex: 1;
        display: flex;

        .desc {
            display: flex;
            flex: 0.7;
            font-family: $istok-font;
            font-weight: 400;
            letter-spacing: 0.56px;
            line-height: 32px;
            color: $blue-main;
            font-size: 20px;
            color: $blue-main;

            @media (min-width: $sm-up) {
                font-size: 15px;
            }

            @media (max-width: $xs-up) {
                font-size: 15px;
                flex: 1;
                text-align: center;
                padding: 5% 4%;
            }

            @media (min-width: 1000px) and (max-width: 1260px) {
                font-size: 15px;
            }
        }
    }
}
</style>
